exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__SearchLink__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__SearchLink__root {\n  display: block;\n  width: 100%;\n  cursor: pointer;\n}\n\n  .DS__SearchLink__root.DS__SearchLink__focus-visible {\n    outline: 2px auto #577edc;\n    outline-offset: 2px;\n  }\n\n  .DS__SearchLink__root.DS__SearchLink__theme_b2b {\n    display: flex;\n    flex: 1 1 100%;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n\n.DS__SearchLink__new_window {\n  display: inline-block;\n  margin-left: 4px;\n}\n\n.DS__SearchLink__new_window svg {\n    -webkit-transform: translateY(-1px);\n            transform: translateY(-1px);\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__SearchLink__root",
	"focus-visible": "DS__SearchLink__focus-visible",
	"theme_b2b": "DS__SearchLink__theme_b2b",
	"new_window": "DS__SearchLink__new_window"
};